module.exports = __webpack_public_path__ + "static/media/5.57871196.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/5.png
// module id = 743
// module chunks = 0